// extracted by mini-css-extract-plugin
export default {"warning":"ViewOptionsButton-module__warning--_mS9K"};